module.exports = __webpack_public_path__ + "static/1-cd5abc3078d5219194b01e3cdb8353be.png";